import React from 'react';
import "./Footer.css";
import {HomeOutlined, PhoneOutlined, MailOutlined, LinkedinOutlined, FacebookOutlined, InstagramOutlined, XOutlined }                  from '@ant-design/icons';

const Footer = () => {
  let socialData = {
    title:"Social",
    options :  [
      {
        title:"LinkedIn",
        logo:<LinkedinOutlined />
      },
      {
        title:"Facebook",
        logo:<FacebookOutlined />
      },
      {
        title:"Instagram",
        logo:<InstagramOutlined />
      },
      {
        title:"Twitter",
        logo:<XOutlined />
      }
    ]
  }

  let AboutUs = {
    title:"About Us",
    options :  [
      {
        title:"United Stated America",
        logo:<HomeOutlined />
      },
      {
        title:"+923075601696",
        logo:<PhoneOutlined />
      },
      {
        title:"usman@gmail.com",
        logo:<MailOutlined />
      },
      {
        title: "",
        logo: ""
      }
    ]
  }


  const menuFunction = (title, options) => {
    return <div className={ "footerMenu" }>
      <h3>{ title }</h3>
      {
        options.map((item, idx)=> <p key={idx}>{
          item.logo
        }<span> {item.title} </span></p>)
      }
    </div>
  }
  return <div className={ "footerContainer" }>
    <div className={ "menuContainer" }>
      <div className={ "footer_logo" }>
        <h2>Rentary</h2>
      </div>
      {
        menuFunction(AboutUs.title, AboutUs.options)
      }
      {
        menuFunction(socialData.title, socialData.options)
      }
    </div>
    <hr/>
    <p className={ "allRights" }>© 2021 All Rights Reserved</p>
  </div>
}

export default Footer